import { usePepI18n } from "../../i18n/usePepI18n";
import {
  ITAAS_INSTITUTION,
  buildItaasOrganizationJsonLd,
  buildPepWebSiteJsonLd,
} from "@itaas/pep-contracts";

/** Inject Organization + WebSite JSON-LD once per layout mount. */
export function InstitutionalJsonLd() {
  const { locale } = usePepI18n();
  const org = buildItaasOrganizationJsonLd();
  const site = buildPepWebSiteJsonLd();
  const graph = {
    "@context": "https://schema.org",
    "@graph": [org, { ...site, inLanguage: locale === "en" ? ["en", "fr"] : ["fr", "en"] }],
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(graph) }}
    />
  );
}

export function PublisherTrustStrip({ compact = false }: { compact?: boolean }) {
  const { locale } = usePepI18n();
  const text =
    locale === "en"
      ? ITAAS_INSTITUTION.relationshipEn
      : ITAAS_INSTITUTION.relationshipFr;

  return (
    <aside
      className={`pep-trust-strip${compact ? " pep-trust-strip--compact" : ""}`}
      aria-label={locale === "en" ? "Publisher" : "Éditeur"}
    >
      <p className="mb-1 small fw-semibold">{ITAAS_INSTITUTION.brandName}</p>
      <p className={`mb-0 ${compact ? "small text-secondary" : "small"}`}>{text}</p>
      <p className="mb-0 small text-secondary mt-1">
        {ITAAS_INSTITUTION.address.addressLocality} — RDC ·{" "}
        <a href={ITAAS_INSTITUTION.institutionalWebsite} rel="noopener noreferrer">
          {ITAAS_INSTITUTION.institutionalWebsite.replace(/^https:\/\//, "")}
        </a>
      </p>
    </aside>
  );
}
